const trimTrailingSlash = (value) => value.replace(/\/$/, "");

const apiBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || "http://207.154.206.132"
);

export const brand = {
  name: "Forpost",
  apiBaseUrl,
  trackingApiBaseUrl:
    process.env.NODE_ENV === "development" && !process.env.REACT_APP_API_BASE_URL
      ? ""
      : apiBaseUrl,
  cabinetUrl:
    process.env.REACT_APP_CABINET_URL ||
    `${apiBaseUrl}/customer_users/sign_in`,
  contact: {
    phone: process.env.REACT_APP_CONTACT_PHONE || "",
    email:
      process.env.REACT_APP_CONTACT_EMAIL || "forpostkz.info@mail.ru",
    address:
      process.env.REACT_APP_CONTACT_ADDRESS ||
      "050062, г. Алматы, Ауэзовский район, ул. Кабдолова, д. 16, корп. 1, 804",
    whatsappUrl: process.env.REACT_APP_WHATSAPP_URL || "",
  },
  legal: {
    name: 'ТОО "Форпост-Казахстан"',
    bin: "131140002751",
    postalCode: "050062",
    kbe: "17",
    director: "Сагнаева Махаббат Толегеновна",
    bankAccounts: [
      {
        bank: 'АО "Банк ЦентрКредит"',
        iik: "KZ868560000006223711",
        bik: "KCJBKZKX",
      },
      {
        bank: 'АО "Kaspi Bank"',
        iik: "KZ787225000013145333",
        bik: "CASPKZKA",
      },
    ],
  },
};

const apiLocales = {
  en: "en",
  kk: "kz",
  kz: "kz",
  ru: "ru",
};

export function buildTrackingApiUrl(code, language) {
  const locale = apiLocales[language] || "ru";
  return `${brand.trackingApiBaseUrl}/api/public/v1/tracking/${encodeURIComponent(code)}?locale=${locale}`;
}
